/* unplugin-vue-components disabled */import script from "./LowBudgetTicker.vue?vue&type=script&setup=true&lang=js"
export * from "./LowBudgetTicker.vue?vue&type=script&setup=true&lang=js"

import "./LowBudgetTicker.vue?vue&type=style&index=0&id=4d171161&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d171161"]])

export default __exports__